import React, { useState, useEffect } from "react"
import classnames from "classnames"
import { Row, Col } from "react-bootstrap"
import { linksBuilder } from "../../../services/utils/linksBuilder"
import { useArtworksResultsAction } from "./useArtworksResultsAction"
import Container from "../../components/Layout/Container"
import { HeadingTitle } from "../../components/Layout/HeadingTitle"
import { HelmetTitle } from "../../components/Layout/HelmetTitle"
import MobileMenu from "../../components/Layout/MobileMenu"
import { SearchSortHeader } from "../../components/Layout/SearchSortHeader"
import Wrapper from "../../components/Layout/Wrapper"
import LeftSide from "../../components/LeftSide"
import { Loader } from "../../components/Layout/Loader"
import { Masonry } from "../../components/Masonry"
import { ApplyButton } from "../ArtworksPage/ApplyButton"
import { FilterButton } from "../ArtworksPage/FilterButton"
import styles from "../ArtworksPage/ArtworksPage.module.scss"
import { useAppContext } from "../../providers/AppProvider"
import { getArtworkSize } from "../../../services/utils/getArtworkSize"
import { getArtworkTitle } from "../../../services/utils/getArtworkTitle"
import { getArtworkSubtitle } from "../../../services/utils/getArtworkSubtitle"

const ArtworksResults = ({ catalog, onFilter, filters }) => {
  const { profile } = useAppContext()
  const [catalogData, setCatalogData] = useState(catalog)
  const {
    loading,
    search,
    collapses,
    clearFilters,
    onClickItem,
    toggleExpand,
    totalFilters,
    showFilters,
    setShowFilters,
    sort,
    setSort,
    sorts,
  } = useArtworksResultsAction({ catalogData, setCatalogData })

  const LoadedElements = () => {
    if (loading) return <Loader />

    const items = catalogData.data.map((item) => ({
      to: linksBuilder.artworks(item.gallery?.domain, item.id, item.title),
      href: "/galleries/[id]/artworks/[artwork]",
      title: getArtworkTitle(item.title),
      image: item.image,
      subtitle: getArtworkSubtitle(item.artistname, item.gallery?.name),
      subSubTitle: getArtworkSize(item.width, item.height),
      lastLine: item.gallery.name,
      textAlign: "left",
    }))

    onFilter(catalogData.total)

    return <Masonry id="artworks" items={items} />
  }

  const Filters = () => (
    <LeftSide
      search={search}
      collapses={collapses}
      clearFilters={clearFilters}
      onClickItem={onClickItem}
      toggleExpand={toggleExpand}
      totalFilters={totalFilters}
      filters={filters}
    />
  )
  return (
    <>
      <Row className="py-2">
        {!profile.embedded && (
          <Col xs={12} sm={12} md={2} className="d-none d-md-block">
            <Filters />
          </Col>
        )}
        <Col xs={12} sm={12} md={!profile.embedded ? 10 : 12}>
          <SearchSortHeader
            hideSearch={true}
            title={``}
            sort={sort}
            setSort={setSort}
            sorts={sorts}>
            <FilterButton onClick={() => setShowFilters(true)} />
          </SearchSortHeader>
          <LoadedElements />
        </Col>
      </Row>
      {showFilters && (
        <MobileMenu className={styles["mobile-menu-container"]}>
          <div
            className={classnames(
              styles["filter-mobile"],
              "position-relative",
            )}>
            <Filters />
            <ApplyButton onClick={() => setShowFilters(false)} />
          </div>
        </MobileMenu>
      )}
    </>
  )
}

export default ArtworksResults